// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header[data-v-86cd4f0a]{color:#504de6}.preview-list[data-v-86cd4f0a]{-ms-overflow-style:none;display:flex;gap:1rem;overflow-y:auto;scroll-behavior:smooth;scrollbar-width:none}.preview-list[data-v-86cd4f0a]::-webkit-scrollbar{display:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
